export function abortable(fn, ...args) {
  let aborted = false;
  let isAborted = () => aborted;
  let abort = () => { aborted = true };

  fn.apply(null, [...args, isAborted]);

  return abort;
}
